export enum Language {
  BRAZILIAN_PORTUGUESE = 0,
  ENGLISH = 1,
  SPANISH = 2
}
